import React from "react"

type Props = {
    isHighlighted   : boolean

    onNavigateUp?   : func
}

export default class FinderNavigateUp extends React.Component<Props> {

    click = () => {
        return this.onNavigateUp()
    }

    onNavigateUp = (e?: any) => {
        e && e.stopPropagation()
        if (this.props.onNavigateUp) {
            return this.props.onNavigateUp()
        }
    }

    render() {
        const classes = Classes("search-item navigate-up flex-row-left-center", {
            'is-highlighted': this.props.isHighlighted
        })

        return (
            <div className  = {classes}
                 onClick    = {this.onNavigateUp}
            >
                <div className="search-item-title flex-1">..</div>
            </div>
        )
    }
}
